import { useCallback, useContext } from 'react';
import AppliedFiltersContext, {
  FinancePayload
} from '~/context/common/AppliedFiltersContext';
import TradeContext from '~/context/common/TradeContext';
import { useFinanceInfo } from '~/context/srp/FinanceContext';
import type { FinanceType } from '~/contracts/common';

export default function useBudgetTradeIn() {
  const { appliedFilters, updateRangeFilter } = useContext(
    AppliedFiltersContext
  );
  const { isTradeInApplied, setTradeInApplied, toggleAppliedTrade } =
    useContext(TradeContext);
  const { minDownPayment, minDownPaymentNoTrade } = useFinanceInfo();

  return useCallback(
    (targetStatus?: boolean) => {
      const appliedFinanceFilters: Partial<FinanceType> =
        appliedFilters.finance ?? {};

      if (targetStatus === undefined) {
        toggleAppliedTrade();
      } else {
        setTradeInApplied(targetStatus);
      }

      const newDownPayment =
        appliedFinanceFilters.downPayment == null
          ? undefined
          : Math.max(
              appliedFinanceFilters?.downPayment,
              isTradeInApplied
                ? minDownPaymentNoTrade ?? minDownPayment
                : minDownPayment
            );

      const payload: FinancePayload = {
        filterKey: 'finance',
        value: {
          downPayment: newDownPayment,
          monthlyPayment: appliedFinanceFilters.monthlyPayment
        }
      };

      // Ensure the user is not using a down payment that is below their min down after toggling their trade off.
      // If they are, update the filter. Otherwise, make a call to Search API to get their updated min down.
      if (
        isTradeInApplied &&
        newDownPayment &&
        appliedFinanceFilters.downPayment !== newDownPayment &&
        appliedFinanceFilters.monthlyPayment !== null
      ) {
        updateRangeFilter(payload);
      }
    },
    [
      appliedFilters.finance,
      isTradeInApplied,
      minDownPayment,
      minDownPaymentNoTrade,
      setTradeInApplied,
      toggleAppliedTrade,
      updateRangeFilter
    ]
  );
}
